<template>
  <div class="app-container vote-detail">
    <basic-container>
      <avue-tabs :option="option" @change="handleChange"></avue-tabs>
      <span v-show="type.prop==='tab1'">
        <h4>基本信息</h4>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="subject"
            label="主题">
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型">
          </el-table-column>
          <el-table-column
            prop="statusEnum"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="participantCount"
            label="参与人数">
          </el-table-column>
        </el-table>
        <br>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="isMultiple"
            label="是否多选">
          </el-table-column>
          <el-table-column
            prop="voteCount"
            label="最多选择/拥有票数">
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间">
          </el-table-column>
        </el-table>
        <br>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
          <el-table-column
            prop="votePermissionList"
            label="参与范围">
            <template slot-scope="scope">
              <span class="tag-name-wrapper" v-for="item in scope.row.votePermissionList" :key="item.id">
                <el-tag size="medium">{{ item.tagName | formatPermission }}</el-tag>
              </span>
              <div v-if="validatenull(scope.row.votePermissionList)">
                <el-tag class="all-tag" size="medium">全部</el-tag>
                <el-tooltip class="item" effect="dark" content="此投票所有人员均可参与" placement="top">
                  <sup><i class="el-icon-question"></i></sup>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="collectType"
            label="收集方式">
          </el-table-column>
          <el-table-column
            prop="insertedTime"
            label="创建时间">
          </el-table-column>
        </el-table>
        <el-row gutter="20" v-if="detail.voteOptionList" class="row-con">
          <el-col :span="24"><h4>投票选项</h4></el-col>
          <el-col :span="6" v-for="item in detail.voteOptionList" :key="item.sort">
            <el-card :body-style="{ padding: '0px' }" class="text-card">
              <img v-if="item.imageUrl" :src="item.imageUrl" class="option-image">
              <div class="option-content box">
                <span class="option-title">{{item.content}}</span>
                <p class="option-desc" v-if="item.description">{{item.description}}</p>
                <p class="option-url" v-if="item.url" @click="handleOpenOptionUrl(item.url)">{{item.url}}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </span>
      <span v-show="type.prop==='tab2'">
        <el-table
          :data="resultData"
          :header-cell-style="{background:'#FAFAFA'}"
          border>
          <el-table-column
            prop="content"
            label="选项标题">
          </el-table-column>
          <el-table-column
            prop="votedCount"
            label="投票数">
          </el-table-column>
          <el-table-column
            prop="participantCount"
            label="参与人数">
            <template slot-scope="scope">
              <a class="count-text" @click="openDialog(scope.row)">{{scope.row.participantCount}}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="proportion"
            label="占比">
          </el-table-column>
        </el-table>
        <el-dialog title="参与投票人员" :visible.sync="dialogVisible">
          <avue-crud ref="crud"
            :page.sync="page"
            :data="tableVoterData"
            :table-loading="tableLoading"
            :option="tableOption"
            @current-change="currentChange"
            @size-change="sizeChange">
            <template slot-scope="scope" slot="avatar">
              <img class="avatar" :src="scope.row.avatar" :alt="scope.row.nickname">
            </template>
          </avue-crud>
          
        </el-dialog>
      </span>
    </basic-container>
  </div>
</template>
<script>
import { getVoteDetail, getRecord, getVoterList } from '@/api/app/vote';
import { statusOptions, typeOptions, collectTypeOptions } from '@/const/crud/app/vote';
export default {
  data() {
    return {
      statusOptions,
      typeOptions,
      collectTypeOptions,
      detail: {},
      type:{},
      option:{
        column: [{
          icon:'el-icon-info',
          label: '详情',
          prop: 'tab1',
        }, {
          icon:'el-icon-tickets',
          label: '结果',
          prop: 'tab2',
        }]
      },
      tableData: [],
      resultData: [],
      optionId: 0,
      dialogVisible: false,
      tableLoading: false,
      tableVoterData: [],
      page: {
        total: 0, // 总记录数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      tableOption: {
        border: true,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        viewBtn: false,
        refreshBtn: false,
        menu: false,
        columnBtn: false,
        align: 'center',
        column: [
          {
            label: '用户ID',
            prop: 'memberId',
          },
          {
            label: '用户名',
            prop: 'nickname',
          },
          {
            label: '头像',
            prop: 'avatar',
            solt: true,
            width: 100
          },
          {
            label: '投票时间',
            prop: 'voteTime',
          }
        ]
      }
    }
  },
  created(){
    this.type = this.option.column[0];
  },
  mounted () {
    this.id = this.$route.params.id
    this.getDetail();
    this.getRecord();
  },
  methods:{
    openDialog(row) {
      this.dialogVisible = true
      this.optionId = row.optionId
      this.getVoterList()
    },
    handleChange(column) {
      this.type = column
    },
    getDetail() {
      getVoteDetail(this.id).then(res => {
        this.detail = this.formatData(res.data.data)
        this.tableData.push(this.detail)
      }).catch(error => {
        this.$message({
          message: '获取投票详情失败',
          type: 'error'
        })
      })
    },
    getRecord(){
      getRecord(this.id).then(res => {
        this.resultData = this.formatResultData(res.data.data)
      }).catch(error => {
        this.$message({
          message: '获取投票结果失败',
          type: 'error'
        })
      })
    },
    getVoterList() {
      this.tableLoading = true
      getVoterList(this.optionId).then(res => {
        this.tableVoterData = res.data.data.records
        this.page.total = res.data.data.total;
        this.tableLoading = false;
      }).catch(err => {
        this.$message({
          message: '获取参与人员列表失败',
          type: 'error'
        })
        this.tableLoading = false;
      })
    },
    formatResultData(list) {
      if (Array.isArray(list)) {
        let n = 0, count = list.reduce((sum, e)=> sum + Number(e.votedCount || 0), 0);
        for (const item of list) {
          item.proportion = this.GetPercent(item.votedCount, count);
        }
      }
      return list
    },
    formatData(obj) {
      if(!this.validatenull(obj.isMultiple))
        obj.isMultiple = obj.isMultiple ? '是' : '否';
      if(!this.validatenull(obj.statusEnum))
        obj.statusEnum = statusOptions.find((v) => (v.value == obj.statusEnum)).label;
      if(!this.validatenull(obj.type))
        obj.type = typeOptions.find((v) => (v.value == obj.type)).label;
      if(!this.validatenull(obj.collectType))
        obj.collectType = collectTypeOptions.find((v) => (v.value == obj.collectType)).label;
      return obj
    },
    GetPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return '-';
      }
      return total <= 0 ? '0%' : (Math.round(num / total * 10000) / 100.00) + '%';
    },
    handleOpenOptionUrl(optionUrl) {
      window.open(optionUrl);
    }
  }
}
</script>
<style lang="scss" scoped>
  .vote-detail{
    .detail-header{
      background-color: #f5f5f5;
    }
    .desc{
      word-wrap:break-word;
      word-break:normal; 
    }
    .vote-permission, .tag-name-wrapper{
      margin-right: 10px;
    }
    .vote-permission span{
      margin-right: 5px;
    }
    .option-image{
      width: 100%;
      height: 150px;
      object-fit: cover;
    }
    .option-content{
      padding: 15px;
      .option-title{
        font-weight: 600;
        font-size: 16px;
      }
      .option-desc,
      .option-url {
        font-size: 14px;
      }
      .option-url {
        color: #409EFF;
        cursor: pointer;
      }
    }
    .participants-box{
      text-align: center;
      .header-img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .el-card.text-card{
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
      border: 1px solid #ebeef5 !important;
    }
    .avatar{
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 50%;
    }
    .count-text{
      color: blue;
      cursor: pointer
    }
    .row-con {
      display: flex;
      flex-flow: row wrap;
    }
    .row-con .el-card {
      height: 100%;
    }
    .all-tag{
      margin-right: 5px;
    }
    .el-icon-question{
      font-size: 15px;
      cursor: pointer
    }
  }
</style>
